package sarka.design.skoria.friends

import kotlinx.serialization.Serializable

/**
 * Wire shapes for the friend system. These mirror the server's
 * `sarka.design.friends` types and must stay in sync with them.
 */

@Serializable
data class Friend(
    val username: String,
    val since: Long,
)

@Serializable
data class IncomingRequest(
    val fromUsername: String,
    val requestedAt: Long,
)

@Serializable
data class OutgoingRequest(
    val toUsername: String,
    val requestedAt: Long,
)

/** Friends, incoming requests and outgoing requests in one payload. */
@Serializable
data class FriendsOverview(
    val friends: List<Friend> = emptyList(),
    val incoming: List<IncomingRequest> = emptyList(),
    val outgoing: List<OutgoingRequest> = emptyList(),
)

@Serializable
data class FriendActionRequest(
    val username: String,
)
